import { useState, useEffect } from 'react';
import ReactDOM from "react-dom/client";
import{ Cart } from "./components/Cart";
import{ CountdownTimer } from "./components/Counter";
import{ MyAccount } from "./components/MyAccount";
import "../styles.css";

const App = () => {
  const [data, setData] = useState(null);

  useEffect(()=> {
    const getData = async () => {
        const bookingData = getCookie('booking-data');
        console.log({bookingData});

        const data = await fetch('https://dev.booking.redcoachusa.com/api/v1/cart', {headers: {
            'Content-Type': 'application/json',
            'booking-data': bookingData 
        }}).then(res => res.json());
        if (data.success) {
          setData(data);
        } 
        console.log({data});
    }
    getData();
  }, [])

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  return (
      <>
        {data && <CountdownTimer initialTime={data.limitTime}/>}
        {data && <Cart data={data}/>}
        <MyAccount />
      </>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("container-cart")
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);